import styles from "../styles/PartnerCard.module.css";
import Image from "next/image";
import { loadStripe } from "@stripe/stripe-js";
import { useState, useEffect } from "react";
import Link from "next/link";
import { useSelector } from "react-redux";
import { generateAuthToken } from "../pages/api/utils";
import { useRouter } from "next/router";
import apiService from "../pages/api/apiService";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import Toastify CSS

import enpopup from "../../locales/en/paymentcontent.json";
import espopup from "../../locales/es/paymentcontent.json";



const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY);

const ProjectCard = ({ name, image, category, description, percentage, collectedAmount, balanceAmount, buttonText, slug, project_name, project_id, Donate_Now, Raised_of, onOpen }) => {
    const modalId = `donationModal-${project_id}`;
    const [price, setPrice] = useState(""); // Store user input
    const loginUserId = useSelector((state) => state.auth.userId);
    const router = useRouter();
    const { query } = router;
    const token = useSelector((state) => state.auth.authToken);
    const [bootstrap, setBootstrap] = useState(null);
    const [content, setContent] = useState(enpopup?.content); // default English
    const Languages = useSelector((state) => state.auth.lang);

    useEffect(() => {
        // Switch between English and Spanish based on Redux language
        setContent(Languages === "es" ? espopup?.content : enpopup?.content);
    }, [Languages]);

    useEffect(() => {
        import("bootstrap/dist/js/bootstrap.bundle.min").then((bs) => {
            setBootstrap(bs);
        });
    }, []);

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                newestOnTop
                closeOnClick
                ltl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                style={{ position: "fixed", zIndex: 9999, top: 0, left: 0, width: "auto", pointerEvents: "none" }}
                containerClass="custom-toast-container"
            />
            <div className={`${styles.card} mb-4`}>

                <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-4">
                    <div className={`${styles.projectImage}`}>
                        <Image
                            className={`${styles.projectImageSize}`}
                            src={image}
                            alt={name}
                            fill={true}  /* Replace width/height with fill */
                            sizes="(max-width: 768px) 100vw, 33vw"
                            priority
                        />
                    </div>

                    <div className={`${styles.projectContent}`}>
                        <a href={`/project-details?slug=${slug}&title=${project_name}`} className={`${styles.nametext} mb-1 fs-5 text-capitalize`}>{name}</a>
                        <p className="line-2 text-muted ellipsis-text mb-3">{description}</p>
                        <div className="progress" style={{ height: "10px" }}>
                            <div
                                className={`${styles.progressbar} progress-bar rounded-pill prog`}
                                role="progressbar"
                                style={{ width: `${percentage}%` }}
                                aria-valuenow={percentage}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            ></div>
                        </div>
                        <p className={`${styles.prgresstext} mb-3 d-flex justify-content-between`}>
                            <span class={`${styles.collected}`}>${collectedAmount}</span>
                            <span className={`${styles.goal}`}>${balanceAmount}</span>
                        </p>

                        {/* Open Modal Button */}
                        <div className="text-center mb-2 d-grid">

                            <button
                                className={`${styles.donateNow} w-100 rounded d-block`}
                                onClick={() => onOpen({
                                    image_path: null,
                                    heading: content?.heading,
                                    title: content?.title,
                                    amount: null,
                                    id: project_id,
                                    description: content?.description,
                                    iScommunity: false,
                                    project: content?.project,
                                    type: "project"
                                })}
                            >
                                {buttonText}
                            </button>

                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default ProjectCard;
